import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiEmployeeAdditionalCompensation,
  ApiEmployeeAdditionalCompensationData,
  ApiEmployeeAdditionalCompensationSave,
} from "@/types/employees/employee-additional-compensation.types.ts";

export const apiEmployeeAdditionalCompensation = {
  create: async function (id: number, payload: ApiEmployeeAdditionalCompensationSave) {
    return api.post<ApiEmployeeAdditionalCompensation>(
      `/api/v1/employees/${id}/additional-compensations`,
      payload
    );
  },
  update: async function (
    id: number,
    positionId: number,
    payload: ApiEmployeeAdditionalCompensationSave
  ) {
    return api.put<ApiEmployeeAdditionalCompensation>(
      `/api/v1/employees/${id}/additional-compensations/${positionId}`,
      payload
    );
  },
  delete: async function (employeeId: number, employeeCompensationId: number) {
    return api.delete<ApiOperationResult>(
      `/api/v1/employees/${employeeId}/additional-compensations/${employeeCompensationId}`
    );
  },
  getAll: async function (employeeId: number) {
    return api.get<ApiEmployeeAdditionalCompensationData>(
      `/api/v1/employees/${employeeId}/additional-compensations`
    );
  },
};
